export class ThemeService implements aboTheme.IThemeProvider {

    private layout: aboTheme.ILayout;
    public isMessageOpen: boolean;
    public isConfigOpen: boolean;

    constructor() {
        this.layout = {
            isSmallSidebar: false,
            isChatOpen: false,
            isFixedHeader: true,
            isFixedFooter: false,
            isBoxed: false,
            isStaticSidebar: false,
            isRightSidebar: false,
            isOffscreenOpen: false,
            isConversationOpen: false,
            isQuickLaunch: false,
            sidebarTheme: '',
            headerTheme: '',
            logo: <string>require('../../images/logo.png'),
            logoDark: <string>require('../../images/logo-dark.png'),
        }

        this.isMessageOpen = false;
        this.isConfigOpen =  false;
    }

    public setLogo = (logo: string) => {
        this.layout.logo = logo;
    }

    public setLogoDark = (logo: string) => {
        this.layout.logoDark = logo;
    }

    public $get(): aboTheme.IThemeService {
        return {
            getLayout: () => { return this.layout; },
            getLogo: () => { return this.layout.logo; },
            getLogoDark: () => { return this.layout.logoDark; },
            setIsMessageOpen: (val:boolean) => { this.isMessageOpen = val; },
            getIsMessageOpen: () => { return this.isMessageOpen; },
            setIsSmallSidebar: (val:boolean) => { this.layout.isSmallSidebar = val; },
            getIsSmallSidebar: () => { return this.layout.isSmallSidebar; }
        };
    }

}


// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/main/theme.provider.ts